// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"724b5ef1","381":"22d7639e"}[chunkId] + ".chunk.js";
};